import cornerstoneTools from "cornerstone-tools";

const BaseTool = cornerstoneTools.importInternal("base/BaseTool");
const { wwwcRegionCursor } = cornerstoneTools.importInternal("tools/cursors");
const triggerEvent = cornerstoneTools.importInternal("util/triggerEvent");

/**
 * @public
 * @class ShowDiffTool
 * @memberof Tools
 * @extends Tools.Base.BaseTool
 */
export class ShowDiffTool extends BaseTool {
  /** @inheritdoc */
  constructor(props = {}) {
    const defaultProps = {
      name: "ShowDiff",
      strategies: {
        DEFAULT: null,
      },
      cursors: {
        DEFAULT: wwwcRegionCursor,
      },
      defaultStrategy: "DEFAULT",
      supportedInteractionTypes: ["Mouse", "Touch"],
      svgCursor: wwwcRegionCursor,
      mixins: []
    };
    super(props, defaultProps);
  }

  passiveCallback(element) {

    this._closeShowDiff(element);
  }

  enabledCallback(element) {
    this._closeShowDiff(element);
  }

  disabledCallback(element) {
    this._closeShowDiff(element);
  }

  _closeShowDiff(element) {
    // const eventType = CUSTOM_TOOLS_EVENTS.SHOW_DIFF_TOOL_CLOSE;
    // const eventData = {
    //   toolName: this.name,
    //   toolType: this.name,
    //   element,
    // };

    // triggerEvent(element, eventType, eventData);
  }
}